import { Component } from '@angular/core';

@Component({
  selector: 'lib-trash',
  imports: [],
  templateUrl: './trash.html',
})
export class Trash {}
